import YetiClient from "./YetiClient";

const YetiNotifications = {
  /**
   * Get notifications list
   *
   * @param {string|date} start_date
   * @param {string} date_filter_field
   * @returns {Object}
   */
  async getNotificationList(start_date) {
    const params = {
      date_filter_start: start_date,
      date_filter_field: "ANY",
      sort: "PORTAL",
      cache: 1,
    };
    return YetiClient.getPaginated("/notifications/notificationlist", {
      params: params,
    });
  },
  /**
   * Get single notification
   *
   * @param {string} notification_id
   * @returns {Object}
   */
  async getNotification(notification_id) {
    return YetiClient.get("/notifications/notification", {
      params: { id: notification_id }
    });
  }
};

export default YetiNotifications;
